import { call, put, takeEvery } from "redux-saga/effects";
import axios from "axios";
import { fetchPlacesSuccess, fetchPlacesFailure, fetchPlacesEditFailure, fetchPlacesEditSuccess  } from "./actions";
import { FETCH_PLACES_DATA, FETCH_PLACES_EDIT_DATA } from "./actionTypes";

function* fetchPlacesDataSaga() {
  try {
    const token = localStorage.getItem("authToken");
    const response = yield call(axios.get, process.env.REACT_APP_WEB_APP_URL + "/api/web/places",{
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
    yield put(fetchPlacesSuccess(response.data));
  } catch (error) {
    yield put(fetchPlacesFailure(error.message));
  }
}

function* fetchPlacesEditDataSaga(action) {
  try {
    const id = action.payload;
    const token = localStorage.getItem("authToken");
    const response = yield call(axios.get, process.env.REACT_APP_WEB_APP_URL + `/api/web/places/${id}`,{
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
    yield put(fetchPlacesEditSuccess(response.data));
  } catch (error) {
    yield put(fetchPlacesEditFailure(error.message));
  }
}

export default function* placesSaga() {
  yield takeEvery(FETCH_PLACES_DATA, fetchPlacesDataSaga);
  yield takeEvery(FETCH_PLACES_EDIT_DATA, fetchPlacesEditDataSaga);
}
